import { useEffect, useState } from 'react'
import { Capacitor } from '@capacitor/core'
import { App as NativeApp } from '@capacitor/app'
import { VERSION, COMMIT } from '../lib/version'
import { t } from '../lib/i18n'
import type { Health } from '../App'

export default function BuildInfo({ health }: { health: Health | null }) {
  const [binary, setBinary] = useState<string | null>(null)
  useEffect(() => {
    if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable('App')) return
    void NativeApp.getInfo().then((info) => setBinary(`${info.version} (${info.build})`)).catch(() => {})
  }, [])
  return <span>
    {Capacitor.isNativePlatform() ? `${t('build.native')} ${binary ?? t('build.unavailable')} · ` : ''}
    {t('build.web')} {VERSION} · {COMMIT} · {health?.environment ?? t('build.unknown')}
    {health && health.commit !== COMMIT ? ` · API ${health.version} ${health.commit}` : ''}
  </span>
}
